import api from "./api";

export async function createQuizBatch(payload = {}) {
  const response = await api.post("/quiz/batch-create", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
